import { Pipe, PipeTransform } from '@angular/core';

import moment from 'moment';
import { PostCrRequest, PostCrResponse } from '../../../../shared/models/v2/post-cr.model';
import { CrView } from '../../../../shared/models/v2/cr.model';
import { ChronoInput } from '../../../../shared/models/chrono.model';
import { CrActiviteInterne } from '../../../../shared/models/activite-interne/activite-interne.model';

/**
 * Filtre les Crs saisie en fonction du jour selectionné
 *
 * @export
 * @class CrOfDayPipe
 * @implements {PipeTransform}
 * @returns {Array} Crs correspondant au jour selectionné
 */
@Pipe({
  name: 'crOfDay',
  standalone: true,
})
export class CrOfDayPipe implements PipeTransform {
  transform(
    crs: (CrView | ChronoInput | CrActiviteInterne | PostCrResponse | PostCrRequest)[],
    filterDay: string
  ): any[] {
    return crs.filter((cr) => {
      if (cr.type === 'cr-response') {
        if (cr.date_creation && cr.intervention_date_fin) {
          if (
            moment(cr.intervention_date_fin).startOf('day').calendar() == moment(filterDay).startOf('day').calendar()
          ) {
            return true;
          }
        }
      }
      if (cr.type === 'cr-view') {
        if (cr.date_creation && cr.intervention_date_fin) {
          if (
            moment(cr.intervention_date_fin).startOf('day').calendar() == moment(filterDay).startOf('day').calendar()
          ) {
            return true;
          }
        }
      }
      if (cr.type === 'cr-activite-interne') {
        let crActiviteInterne = cr as CrActiviteInterne;
        if (
          crActiviteInterne.cr_activite_interne_date_fin &&
          moment(crActiviteInterne.cr_activite_interne_date_fin).startOf('day').isSame(moment(filterDay).startOf('day'))
        ) {
          return true;
        }
      }
      if (cr.type === 'post-cr-request') {
        if (cr.date_creation && cr.intervention_date_fin) {
          if (
            moment(cr.intervention_date_fin).startOf('day').calendar() == moment(filterDay).startOf('day').calendar()
          ) {
            return true;
          }
        }
      }
      return false;
    });
  }
}
